import { colors } from "@material-ui/core";

export enum EnableStatus {
  activated = "activated",
  deactivated = "deactivated",
  neutral = "neutral"
}

export function statusColor(status: EnableStatus, degradation: number) {
  switch (status) {
    case EnableStatus.activated:
      return colors.green[degradation];
    case EnableStatus.deactivated:
      return colors.red[degradation];
    case EnableStatus.neutral:
      return colors.grey[degradation];
  }
}
